import React from "react";
import { Col, Row } from "react-bootstrap";
import { WfControlProps } from "./ControlProps";
import { Input, InputProps } from "antd";
import ComponentLabel from "../../../../../../components/ControlComponents/ComponentLabel";

export function WfText({
  layout,
  layoutLength,
  fieldState,
  inputProps,
}: Readonly<WfControlProps>) {
  return (
    <>
      <ComponentLabel
        colText={2}
        rowIdx={1}
        colIdx={0}
        template={layout.template}
      />
      <Col xs={12} lg={layoutLength === 1 ? 10 : 4}>
        <Input type="text" {...(inputProps as InputProps)} />
        {fieldState.error && (
          <>
            <small className="text-danger">{fieldState.error.message}</small>
          </>
        )}
      </Col>
    </>
  );
}
